/// IMPORTS
import {
  WorkspaceUnitGetQuery,
  WorkspaceUnitGetResponse,
  WorkspaceUnitPostBody,
  WorkspaceUnitPostResponse,
  WorkspaceUnitPutBody,
  WorkspaceUnitPutResponse,
  WorkspaceUnitDeleteQuery,
  WorkspaceUnitDeleteResponse,
  WorkspaceUnitsGetQuery,
  WorkspaceUnitsGetResponse,
  WorkspaceUnitPostsBody,
  WorkspaceUnitPostsResponse,
  WorkspaceUnitPutsBody,
  WorkspaceUnitPutsResponse,
  WorkspaceUnitDeletesQuery,
  WorkspaceUnitDeletesResponse,
  WorkspaceUnitOrderPutBody,
  WorkspaceUnitOrderPutResponse,
} from 'generatedInterfaces';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Workspace } from '../workspace';

export class UnitsOfflineEndpoint {
  /// PROPERTIES

  /// CUSTOM PROPERTIES

  ///

  constructor() {
    this.customConstructor();
  }

  customConstructor() {
    /// CUSTOM CONSTRUCTOR CONTENT
    ///
  }

  /// METHODS

  // Delete a local entity
  public delete(obj: Workspace['units'][0]) {
    const units = this.getMany();
    units.splice(
      units.findIndex((entity) => {
        if (entity.id === obj.id) {
          return true;
        }
        return false;
      }),
      1
    );
    this.setEntities(units);
  }

  // Push or update an entity
  public pushOrUpdate(obj: Workspace['units'][0]): void {
    const units = this.getMany();
    const index = units.findIndex((entity) => entity.id === obj.id);
    if (index === -1) {
      units.push(obj);
    } else {
      units[index] = obj;
    }
    this.setEntities(units);
  }

  // Get all the local entities
  public getMany(obj?: any): Workspace['units'] {
    if (localStorage.getItem('units') === null) {
      return [];
    }
    let entities = JSON.parse(
      localStorage.getItem('units') as any
    ) as Workspace['units'];

    if (obj) {
      return entities.filter((entity) => {
        let hasProperties = false;
        for (const key in obj) {
          hasProperties = true;
          if (obj.hasOwnProperty(key) && entity.hasOwnProperty(key)) {
            if ((<any>entity)[key] === (<any>obj)[key]) {
              return true;
            }
          }
        }
        if (!hasProperties) return true;
        return false;
      });
    }

    return entities;
  }

  // Get one of the local entities
  public getOne(obj: any): Workspace['units'][0] {
    let units = this.getMany();
    // Filter for all the value of obj
    units = units.filter((entity) => {
      let hasProperties = false;
      for (const key in obj) {
        hasProperties = true;
        if (obj.hasOwnProperty(key) && entity.hasOwnProperty(key)) {
          if ((<any>entity)[key] === (<any>obj)[key]) {
            return true;
          }
        }
      }
      if (!hasProperties) return true;
      return false;
    });

    return units[0];
  }

  // Set the entire entities array
  public setEntities(obj: Workspace['units']): void {
    localStorage.setItem('units', JSON.stringify(obj));
  }

  /// CUSTOM METHODS

  ///
}
